import {Component, Input} from '@angular/core';
import {FilterModelDto} from "../../../../models/filter.model";

@Component({
  selector: 'app-return-page-filter',
  templateUrl: './return-page-filter.component.html',
  styleUrls: ['./return-page-filter.component.scss']
})
export class ReturnPageFilterComponent {
  @Input() filterCurrencies: FilterModelDto[] | undefined
  @Input() filterBanks: FilterModelDto[] | undefined

  filterSumFrom: FilterModelDto = {
    fieldName: 'amount_from',
    value: '',
    description: ''
  }

  filterSumTo: FilterModelDto = {
    fieldName: 'amount_to',
    value: '',
    description: ''
  }

  filterStart: FilterModelDto = {
    fieldName: 'date_from',
    value: '',
    description: ''
  }

  filterEnd: FilterModelDto = {
    fieldName: 'date_to',
    value: '',
    description: ''
  }
}
